import { Block } from '@openlaw-au/types';
import { FunctionComponent } from 'react'; /**/
import FragmentRenderer from './fragmentRenderer';
import BlockRenderer from './blockRenderer';

interface Props {
  block: Block;
}

const TableRenderer: FunctionComponent<Props> = ({ block }) => {
  return (
    <div>
      <table>
        <tbody>
          {block.blocks.map((b, idx) => {
            switch (b.type) {
              case 'TableBodyBlock': {
                return (
                  <tbody>
                    <BlockRenderer block={b} key={idx} />
                  </tbody>
                );
              }
              case 'TableHeadingBlock': {
                return (
                  <tr key={idx}>
                    <th>
                      <FragmentRenderer frags={b.fragments} />
                    </th>
                  </tr>
                );
              }
              case 'TableRowBlock': {
                return b.blocks.map((row, innerIdx) => {
                  const [levelMeta] = row.meta;
                  const indentLevel = `pl-${
                    (parseInt(levelMeta.value.slice(0, 1)) - 1) * 3
                  }`;

                  return (
                    <tr className={'align-top'} key={innerIdx}>
                      <td>
                        <div className={indentLevel}>
                          <FragmentRenderer frags={row.fragments} />
                        </div>
                      </td>
                      <td>
                        {row.blocks.map((col, k) => {
                          return (
                            <FragmentRenderer frags={col.fragments} key={k} />
                          );
                        })}
                      </td>
                    </tr>
                  );
                });
              }
            }
            return (
              <tr key={idx}>
                <div key={idx} />
              </tr>
            );
          })}{' '}
        </tbody>
      </table>
    </div>
  );
};

export default TableRenderer;
